import { Tag } from "antd";
import { ListPage } from "../../components/ListPage";
import { SiteLabel } from "../../components/SiteLabel";
import type { MRN } from "../../api-models";

const SOURCE_LABELS: Record<string, string> = {
  GIN: "Goods Issue (GIN)",
  TRANSFER_NOTE: "Transfer Note",
  PO: "Direct from supplier (PO)",
  GIN_DIRECT: "Supplier to site (GIN Direct)",
};

// MRNs are always raised from the document being received against — a GIN, a Transfer
// Note, a GIN Direct, or a direct-delivery PO — so this page is a register, not a create
// form. The "Receive" action lives on those documents' own pages (spec §12).
export default function MRNsListPage() {
  return (
    <ListPage<MRN>
      title="Material Receipts (MRN)"
      endpoint="/mrns"
      searchPlaceholder="Search doc no or supplier GDN..."
      linkTo={(r) => `/receipts/${r.id}`}
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Source", dataIndex: "sourceType", sorter: true, render: (v) => <Tag>{SOURCE_LABELS[v] ?? v}</Tag> },
        { title: "Site", render: (_, r) => <SiteLabel site={r.site} fallback="Central" /> },
        { title: "Supplier GDN", dataIndex: "supplierGdnNo", sorter: true, render: (v) => v || "—" },
        { title: "Received", key: "receivedAt", sorter: true, render: (_, r) => new Date(r.receivedAt).toLocaleDateString() },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div>{SOURCE_LABELS[r.sourceType] ?? r.sourceType}</div>
          <div><SiteLabel site={r.site} fallback="Central" /></div>
        </div>
      )}
    />
  );
}
